export default "__VITE_ASSET__84b1b152__"